// removed by extract-text-webpack-plugin
module.exports = {"root":"AutosuggestManu-module-root-1S_eJ","cross-btn":"AutosuggestManu-module-cross-btn-Vrd3q","crossBtn":"AutosuggestManu-module-cross-btn-Vrd3q","home":"AutosuggestManu-module-home-694j8","is-car-plate-search":"AutosuggestManu-module-is-car-plate-search-3RYSu","isCarPlateSearch":"AutosuggestManu-module-is-car-plate-search-3RYSu","hint":"AutosuggestManu-module-hint-1x_dv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AutosuggestManu/AutosuggestManu.module.scss
// module id = 995
// module chunks = 0